<template>
  <div class="member_list">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item, index) in $route.meta.breadUrl" :key="index">
          <router-link v-if="item.url" :to="item.url">{{ item.name }}</router-link>
          <a v-else>{{ item.name }}</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="memberList_wrap">
      <div class="tab_wrap4_wrap">
        <el-tabs v-model="projectName" @tab-click="handleClick" class="tab_wrap4">
          <el-tab-pane label="全部" name="default"></el-tab-pane>
          <el-tab-pane label="招标项目" name="招标专区"></el-tab-pane>
          <el-tab-pane label="非招标项目" name="非招标专区"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="searchWrap">
        <el-input class="searchInput" v-model="searchInput" placeholder="请输入搜索内容" @keyup.enter.native="searchDetail()">
          <i class="el-icon-search elIconSearch_cus1" slot="suffix" @click.stop="searchDetail()"></i>
        </el-input>
      </div>
      <ul class="li_wrap list_minHeight re_liwrap line_li_wrap">
        <li class="clear" v-for="(item, index) in biddlist1" :key="index" @click.stop="goDetail(item.id, item.cateid)">
          <span class="type_btn">【{{ item.type }}】</span>
          <span class="li_left overell">{{ item.title }}</span>
          <span class="li_right">{{ item.date }}</span>
        </li>
      </ul>
      <el-pagination class="page_wrap" background :page-size="pageSize" layout="prev, pager, next" :total="quesLength" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import LeftTab from '@/components/common/LeftTab'

export default {
  name: 'news',
  components: { LeftTab },
  data() {
    return {
      projectName: 'default',
      searchInput: '',
      quesLength: 0,
      pageSize: 11,
      pageIndex: 1,
      biddlist1: []
    }
  },
  mounted() {
    this.getInformationData('default')
  },
  methods: {
    getInformationData(typeName) {
      var that = this
      let config = {}
      if (typeName == 'default') {
        config = {
          params: {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            title: this.searchInput
          }
        }
      } else {
        config = {
          params: {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            title: this.searchInput,
            typeName: typeName
          }
        }
      }

      this.getRequest('/Information/GetMemberCenterList', config)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.biddlist1 = data.infoList
            this.quesLength = data.quesLength
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleClick() {
      this.getInformationData(this.projectName)
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getInformationData(this.projectName)
    },
    searchDetail() {
      this.pageIndex = 1
      this.getInformationData(this.projectName)
    },
    goDetail(id, cateId) {
      let routerData = this.$router.resolve({
        name: 'detail',
        query: { id: id, cateId: cateId, purchaseType: 0 }
      })
      window.open(routerData.href, '_blank')
    }
  }
}
</script>
<style scoped lang="scss">
.member_list .list_minHeight {
  min-height: 500px;
}
.searchWrap {
  display: flex;
  position: absolute;
  right: 0;
  top: 90px;
  span {
    font-weight: bold;
  }
  ::v-deep.el-input__suffix {
    top: 3px;
  }
}
</style>
